module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAA1UlEQVQ4je3SPUpDURTE8d99ppIUgpVaCKnsJb07sFXclwvQQtyAlUU2YG1hYx8bSfzAIz6rhGdyIei9YuOUw8yfOXBSRJzjUD2NUkS0FYGgwbQyc9qg9tL2N85vGzxUhr6kiBjgAPd4K4A1GOAmRcTMPMZWAfQVp9CFvmOtAAobeOx1jDvsLYSucJ0p7+NkwZvgA3pL8a86w2XGH2agc3XPv80sfcY409tEP7N0B5NVS9exuyKzpOa7hX/o30NTIWve70K3C6H9Gbj7pxc48vPFIzzBJyKNNT7AF8JhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/1.png
// module id = Hvmv
// module chunks = 1